import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';

const MainLayout = () => {
  return (
    <div className="main-layout">
      <Header />
      
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        
        <main className="main-content">
          <div className="content-area">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
